module.exports = __webpack_public_path__ + "img/gasnatural.307cd170.svg";